var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.029,
    height: 17,
    viewBox: "0 0 18.029 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-pencil",
    d: "M17.782,1.928A2.74,2.74,0,0,1,20.6,4.584a2.547,2.547,0,0,1-.563,1.594L18.909,7.241,14.965,3.522l1.127-1.063a2.917,2.917,0,0,1,1.69-.531ZM3.7,14.147,2.571,18.928l5.071-1.063L18.064,8.037,14.12,4.319ZM15.169,7.964,7.282,15.4l-.971-.916L14.2,7.048Z",
    transform: "translate(-2.571 -1.928)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.927d75964ef92cf8431ad9add0bb8667.svg";
export { ForwardRef as ReactComponent };